<div class="surface-ground flex items-center justify-center min-h-screen min-w-screen overflow-hidden">
  <div class="flex flex-col items-center justify-center">
    <div class="text-center mb-2">
      <img src="assets/layout/images/logo.svg" alt="SWI logo" class="mb-5 w-[3rem] flex-shrink-0" />
    </div>
    <div
      style="
        border-radius: 56px;
        padding: 0.3rem;
        background: linear-gradient(180deg, var(--primary-color) 10%, rgba(33, 150, 243, 0) 30%);
      "
    >
      <div class="w-full surface-card py-8 px-5 sm:px-8 flex flex-col items-center" style="border-radius: 53px">
        <span class="text-blue-500 font-bold text-3xl">404</span>
        <h1 class="text-900 font-bold text-3xl lg:text-5xl mb-2">{{ 'auth.notFound.notFound' | translate }}</h1>
        <div class="text-600 mb-5">{{ 'auth.notFound.requestedResource' | translate }}</div>
        <a [routerLink]="['/']" class="w-full flex items-center py-5 border-300 border-bottom-1">
          <span class="flex justify-center items-center bg-cyan-400 rounded-md" style="height: 3.5rem; width: 3.5rem">
            <i class="text-50 pi pi-fw pi-table text-2xl"></i>
          </span>
          <span class="ml-4 flex flex-col">
            <span class="text-900 lg:text-xl font-medium mb-0 block">{{
              'auth.notFound.frequentlyAskedQuestions' | translate
            }}</span>
            <span class="text-600 lg:text-xl">{{ 'auth.notFound.ultriciesMiQuis' | translate }}.</span>
          </span>
        </a>
        <a [routerLink]="['/']" class="w-full flex items-center py-5 border-300 border-bottom-1">
          <span class="flex justify-center items-center bg-orange-400 rounded-md" style="height: 3.5rem; width: 3.5rem">
            <i class="pi pi-fw pi-question-circle text-50 text-2xl"></i>
          </span>
          <span class="ml-4 flex flex-col">
            <span class="text-900 lg:text-xl font-medium mb-0">{{ 'auth.notFound.solutionCenter' | translate }}</span>
            <span class="text-600 lg:text-xl">{{ 'auth.notFound.phasellusFaucibus' | translate }}</span>
          </span>
        </a>
        <a [routerLink]="['/']" class="w-full flex items-center mb-5 py-5 border-300 border-bottom-1">
          <span class="flex justify-center items-center bg-indigo-400 rounded-md" style="height: 3.5rem; width: 3.5rem">
            <i class="pi pi-fw pi-unlock text-50 text-2xl"></i>
          </span>
          <span class="ml-4 flex flex-col">
            <span class="text-900 lg:text-xl font-medium mb-0">{{
              'auth.notFound.permissionManager' | translate
            }}</span>
            <span class="text-600 lg:text-xl">{{ 'auth.notFound.accumsanInNisl' | translate }}</span>
          </span>
        </a>
      </div>
    </div>
  </div>
  <ul class="absolute top-0 right-0 pr-4">
    <li class="flex flex-wrap items-end justify-center">
      <p-button
        [rounded]="true"
        variant="text"
        class="p-button-lg p-0 mr-3"
        (click)="layoutService.onToggleDarkMode()"
        pTooltip="{{ 'layout.darkMode' | translate }}"
        showDelay="800"
        tooltipPosition="top"
        icon="pi pi-moon"
      />
      <app-language-selector />
      <app-scale />
    </li>
  </ul>
  <div class="absolute bottom-2 left-1/2 -translate-x-1/2">
    <div class="flex items-center justify-center pt-2">
      <p-button class="flex items-center">
        <img src="assets/layout/images/logo.svg" alt="Logo" class="mr-2 size-6" />

        by <a href="https://www.intechnity.com/" target="_blank" class="ml-1"> Intechnity</a>
      </p-button>
    </div>
  </div>
</div>
